import { render, staticRenderFns } from "./post.vue?vue&type=template&id=64dd7b59&scoped=true&"
import script from "./post.vue?vue&type=script&lang=ts&"
export * from "./post.vue?vue&type=script&lang=ts&"
import style0 from "./post.vue?vue&type=style&index=0&id=64dd7b59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd7b59",
  null
  
)

export default component.exports